var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-[100vw] flex justify-center items-center text-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Text Centered"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }